module.exports = __webpack_public_path__ + "img/icon1.2b75b1b8.png";